import { render, staticRenderFns } from "./historyRemove.vue?vue&type=template&id=f2553322"
import script from "./historyRemove.vue?vue&type=script&lang=js"
export * from "./historyRemove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports